import React from "react";
import styled from "styled-components/macro";

interface TabLayoutProps {
	children?: React.ReactNode;
}

const TabLayout: React.FC<TabLayoutProps> = ({ children }) => {
	return (
		<StyledContainer>
			<div>{children}</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	padding: 0 var(--space-5);

	button:not(:last-child) {
		margin-right: var(--space-2);
	}
`;

export default TabLayout;
